import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import PositionsList from './PositionList';

//redux

const PositionList = () => {
    const breadcrumbLinks = [
        { to: '#', label: 'Inicio' },
        { to: '#', label: 'Abastecimiento' },
        { to: '#', label: 'Configuración' },
    ];

    return (
        <React.Fragment>
            <UiContent />
            <div className='page-content'>
                <Container fluid>
                    <BreadCrumb title='Cargos EPP' links={breadcrumbLinks} />
                    <PositionsList/>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default PositionList;